import script from "./AboutSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=0b11ec5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b11ec5c"]])

export default __exports__